import { PoolName } from "@/shared/constants/pools";

import { Token } from "../constants";

export const getTokensByPoolName = (poolName: PoolName) => {
  const tokensByPoolName: Record<PoolName, [Token, Token]> = {
    [PoolName.ArbUsdc]: [Token.ARB, Token.USDC],
    [PoolName.WethUsdc]: [Token.WETH, Token.USDC],
    [PoolName.GmxUsdc]: [Token.GMX, Token.USDC],
    [PoolName.WbtcWeth]: [Token.WBTC, Token.WETH],
    [PoolName.ArbUsdce]: [Token.ARB, Token.USDCE],
    [PoolName.WethUsdce]: [Token.WETH, Token.USDCE],
  };
  return tokensByPoolName[poolName];
};
